import api from "./api";

/**
 * Upload a file to persistent Emergent object storage via /api/admin/upload.
 * Returns an absolute URL suitable for <img src>.
 * Falls back gracefully on errors — caller should handle the throw.
 */
export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const base = process.env.REACT_APP_BACKEND_URL || "";
  // Backend returns { url: "/api/files/..." } — make it absolute
  return data.url.startsWith("http") ? data.url : `${base}${data.url}`;
}

/**
 * Convenience wrapper: reads file input event, uploads it, returns URL.
 * Enforces client-side type + size limits with friendly errors.
 */
export async function pickAndUploadImage(file, { maxMB = 15 } = {}) {
  if (!file) throw new Error("No file selected");
  if (!file.type.startsWith("image/")) throw new Error("Please choose an image file");
  if (file.size > maxMB * 1024 * 1024) throw new Error(`Image is too large (max ${maxMB} MB)`);
  return uploadFile(file);
}
